import axios from '@/util/axios'
import { NEW_API_CONFIG, DEV_API_TOKEN } from '@/util/constants'
import store from '@/store'
import { handleApiError as handleError } from '@/util/axios_common'

/**
 * 職業一覧API
 */
export const listJobs = (params = {}) => {
  const token = process.env.NODE_ENV === 'development'
    ? DEV_API_TOKEN
    : store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/IQ/001', r).catch(handleError)
}

/**
 * 住所取得API
 */
export const listAddresses = (params = {}) => {
  const token = process.env.NODE_ENV === 'development'
    ? DEV_API_TOKEN
    : store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/IQ/002', r).catch(handleError)
}

/**
 * 選択パッケージ＆ライセンス情報一覧API
 */
export const listPackageAndLicenses = (params = {}) => {
  const token = process.env.NODE_ENV === 'development'
    ? DEV_API_TOKEN
    : store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/IQ/003', r).catch(handleError)
}

/**
 * 無料トライアルメール登録API
 */
export const registerFreeTrial = (params = {}) => {
  const token = process.env.NODE_ENV === 'development'
    ? DEV_API_TOKEN
    : store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/IQ/004', r).catch(handleError)
}

/**
 * 無料トライアル・見積り＆お問い合わせ登録API
 */
export const registerTrialEstimateInquiry = (params = {}) => {
  const token = process.env.NODE_ENV === 'development'
    ? DEV_API_TOKEN
    : store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/IQ/005', r).catch(handleError)
}

/**
 * お問い合わせ登録API
 */
export const registerInquiry = (params = {}) => {
  const token = process.env.NODE_ENV === 'development'
    ? DEV_API_TOKEN
    : store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/IQ/006', r).catch(handleError)
}

/**
 * お見積もり登録API
 */
export const registerEstimate = (params = {}) => {
  const token = process.env.NODE_ENV === 'development'
    ? DEV_API_TOKEN
    : store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/IQ/007', r).catch(handleError)
}

/**
 * お見積もり内容確認API
 */
export const confirmEstimate = (params = {}) => {
  const token = process.env.NODE_ENV === 'development'
    ? DEV_API_TOKEN
    : store.state.auth.token
  const organizationId = store.state.profile.organization_id

  // paramsにtokenが設定されている場合は、その値がtokenとして優先される
  // (メールのURLからアクセスした場合のトークン認証時)
  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/IQ/008', r).catch(handleError)
}

/**
 * 顧客基本情報文字エンコーディングチェックAPI
 */
export const checkEncoding = (params = {}) => {
  const token = process.env.NODE_ENV === 'development'
    ? DEV_API_TOKEN
    : store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/IQ/009', r).catch(handleError)
}

/**
 * 新規契約申込完了API
 */
export const completeNewApplication = (params = {}) => {
  const token = process.env.NODE_ENV === 'development'
    ? DEV_API_TOKEN
    : store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/IQ/010', r).catch(handleError)
}

/**
 * 新規契約申込完了API（LCログイン後）
 */
export const completeLoggedinNewApplication = (params = {}) => {
  const token = process.env.NODE_ENV === 'development'
    ? DEV_API_TOKEN
    : store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/IQ/011', r).catch(handleError)
}

/**
 * 新規契約申込可能判定API
 */
export const isAbleToCompleteAgreement = (params = {}) => {
  const token = process.env.NODE_ENV === 'development'
    ? DEV_API_TOKEN
    : store.state.auth.token
  const organizationId = store.state.profile.organization_id
  
  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/IQ/012', r).catch(handleError)
}
